import http from '../interceptors/Intercepter';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const retrieveFacilities = async (username) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.get('/api/facility/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateFacility = async (username, facilityVo) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.put('/api/facility/update', facilityVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveDropdowns = async (username) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.get('/api/facility/view/dropdown', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveSitesForParticipantStudy = async (
  username,
  participantExternalReference,
  studyExternalReference
) => {
  try {
    const params = {
      participantExternalReference: participantExternalReference,
      studyExternalReference: studyExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/facility/view/study/participant', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewSiteStaff = async (username, facilityExternalReference) => {
  try {
    const params = {
      facilityExternalReference: facilityExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/facility/view/site-staff', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const synchroniseFacilities = async (username) => {
  try {
    const params = { username };

    const { data } = await http.put('/api/facility/sync', undefined, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveDropdownsForAddStudyToSite = async (username, studyExternalReference) => {
  try {
    const params = {
      studyExternalReference: studyExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/facility/view/dropdown/add-study-site/', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
